<ng-lottie class="animation" lottie [options]="options" />
